module.exports = __webpack_public_path__ + "static/media/12.197d7bd7.JPG";